/* eslint-disable @typescript-eslint/naming-convention */
// Package Imports
import { type SizeType } from 'antd/es/config-provider/SizeContext';
import colors from './colors';

const viewportWidth = window.innerWidth;
// const colors = {
//   // primary: '#4F46E5',
//   // yellow: '#FCC015',

//   primary: '#274ECB',
//   secondary: '#F5BF13',
//   placeholder: '#808080',
//   heading: '#5A4FCF',
//   subheading: '#808080',
//   white: '#FFFFFF',
//   black: '#000000',
//   mutedPrimary: '#021E4C',
//   mutedSecondary: '#BD9D64',
//   mutedWhite: '#EBEBEB',
//   mutedBlack: '#908C89',
// };

const ConfigStyle = {
  theme: {
    components: {
      Button: {
        borderRadius: 0,
        colorPrimary: colors.primary,
        primaryColor: colors.white,
        colorPrimaryHover: colors.mutedPrimary,
      },
      Layout: {
        siderBg: '#FF0000',
        headerColor: colors.mutedBlack,
      },
      Table: {
        colorTextHeading: colors.black,
        // colorBgContainer: "#fff",
      },
      ...(viewportWidth > 900 && {
        Menu: {
          subMenuItemBg: colors.white,
          itemSelectedColor: colors.black,
          itemSelectedBg: colors.secondary,
          itemBg: colors.white,
          itemColor: '#6c6666',
          itemHoverColor: colors.black,
          itemHoverBg: colors.secondary,
        },
      }),
      // Card: {
      //   colorTextHeading: colors.heading,
      //   colorBgContainer: '#fff',
      //   colorPrimary: '#001E4C',
      // },
      // Form: {
      //   colorTextHeading: 'black',
      //   labelColor: 'black',
      // },
      Input: {
        colorTextPlaceholder: colors.mutedBlack,
      },
      Checkbox: {
        colorPrimary: colors.primary,
      },
      Select: {
        selectorBg: colors['neutral-20'],
        colorBorder: colors.selectBorder,
        optionSelectedFontWeight: 400,
        colorBgElevated: colors.white,
        optionSelectedBg: colors.white,
        optionSelectedColor: colors['primary-500'],
        optionSelectedBorderColor: colors['primary-100'],
        optionActiveBg: colors['primary-50'],
        optionFontSize: 16,
      },
      Radio: {
        buttonColor: colors.primary,
        buttonBg: colors.primary,
        buttonCheckedBg: colors.primary,
        colorPrimaryActive: colors.primary,
        buttonSolidCheckedColor: colors.primary,
        buttonSolidCheckedBg: colors.primary,
        buttonSolidCheckedActiveBg: colors.primary,
        // radioSize: 16,
        // dotSize: 8,
      },
      //   DatePicker: {
      //     colorTextPlaceholder: colors.placeholder,
      //   },
      //   Dropdown: {
      //     colorTextPlaceholder: colors.placeholder,
      //   },
      //   Typography: {
      //     colorTextHeading: colors.heading,
      //     // fontFamily: 'Inter',
      //   },
    },
    token: {
      fontFamily: `'Noto Sans','san-serif'`,
      fontSize: 16,
      // colorBgBase:colors.mutedWhite,
      // colorBgContainer: colors.white
      // colorPrimaryHover: colors.primary,
    },

    // h2: {
    //   fontWeightStrong: true,
    // },
  },

  componentSize: 'large' as SizeType,
  labelfontWeight: '600',
  labelColor: colors.black,
  colors,
};

export default ConfigStyle;
